import React, { createContext } from "react";

// Create context
export const CartContext = createContext();

export class CartProvider extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      cart: []
    };

    this.addToCart = this.addToCart.bind(this);
    this.updateQuantity = this.updateQuantity.bind(this);
    this.removeFromCart = this.removeFromCart.bind(this);
    this.clearCart = this.clearCart.bind(this);
  }

  componentDidMount() {
    const storedCart = localStorage.getItem("cart");
    if (storedCart) {
      try {
        this.setState({ cart: JSON.parse(storedCart) });
      } catch (e) {
        console.error("Invalid cart data");
      }
    }
  }

  componentDidUpdate(_, prevState) {
    if (prevState.cart !== this.state.cart) {
      localStorage.setItem("cart", JSON.stringify(this.state.cart));
    }
  }

  // ✅ ADD TO CART (VARIATION-SAFE)
  addToCart(product) {
    this.setState(prev => {
      const existing = prev.cart.find(
        item =>
          item.productId === product.productId &&
          item.variationId === product.variationId
      );

      if (existing) {
        return {
          cart: prev.cart.map(item =>
            item.productId === product.productId &&
            item.variationId === product.variationId
              ? {
                  ...item,
                  quantity: item.quantity + (product.quantity || 1)
                }
              : item
          )
        };
      }

      return {
        cart: [
          ...prev.cart,
          {
            productId: product.productId,
            title: product.title,
            product_image: product.product_image,
            vendorName: product.vendorName,
            store_id: product.store_id,

            quantity: product.quantity,

            offer: product.offer,

            variationId: product.variationId,
            variationName: product.variationName
          }
        ]
      };
    });
  }

  updateQuantity(productId, variationId, quantity) {
    this.setState(prev => ({
      cart: prev.cart
        .map(item =>
          item.productId === productId &&
          item.variationId === variationId
            ? { ...item, quantity }
            : item
        )
        .filter(item => item.quantity > 0)
    }));
  }

  // ✅ REMOVE ITEM
  removeFromCart(productId, variationId) {
    this.setState(prev => ({
      cart: prev.cart.filter(
        item =>
          item.productId !== productId ||
          item.variationId !== variationId
      )
    }));
  }

  // ✅ CLEAR CART
  clearCart() {
    this.setState({ cart: [] });
    localStorage.removeItem("cart");
  }

  render() {
    return (
      <CartContext.Provider
        value={{
          cart: this.state.cart,
          addToCart: this.addToCart,
          updateQuantity: this.updateQuantity,
          removeFromCart: this.removeFromCart,
          clearCart: this.clearCart
        }}
      >
        {this.props.children}
      </CartContext.Provider>
    );
  }
}